(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function applyShopAllMobileOffset() {
    if (!mobileQuery.matches) return;

    document.querySelectorAll('.section-rk-collection-accordion .rk-accordion__shop-all').forEach((button) => {
      button.style.setProperty('transform', 'translateY(-42px)', 'important');
    });
  }

  applyShopAllMobileOffset();
  document.addEventListener('DOMContentLoaded', applyShopAllMobileOffset);
  window.addEventListener('load', applyShopAllMobileOffset);
  document.addEventListener('shopify:section:load', applyShopAllMobileOffset);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', applyShopAllMobileOffset);
  }
})();
